import { EventEmitter, Injectable } from '@angular/core';
import { Edge } from '@swimlane/ngx-graph';
import { BuyPlan } from '../../modals/buy-plan-modal/buy-plan-modal.component';
import { NgxGraphNode } from '../interfaces/ngx-graph-local';

interface CreateTreeGraphData {
	currentNode: NgxGraphNode;
	nodes: NgxGraphNode[];
	links: Edge[];
	sources: string[];
	onlyView?: boolean;
}
@Injectable({
	providedIn: 'root'
})
export class EmittersService {
	logoEmiter = new EventEmitter();
	refreshPlan = new EventEmitter();
	preferencesEmiter = new EventEmitter();
	appearanceEmiter = new EventEmitter();
	addLogoEmiter = new EventEmitter();
	languajeEmiter = new EventEmitter();
	addUserCompany = new EventEmitter();
	chooseFlowModal = new EventEmitter();
	feedbackResumenModal = new EventEmitter();
	products = new EventEmitter();
	invitateExternalCompany = new EventEmitter();
	processComponent = new EventEmitter();
	findCodeModal = new EventEmitter();
	configurationFieldModal = new EventEmitter();
	createRole = new EventEmitter();
	createRoleOrigin = new EventEmitter();

	refactorListReadingRole = new EventEmitter();

	loadingService = new EventEmitter();

	georeferenceModal = new EventEmitter();
	productModal = new EventEmitter();

	account = new EventEmitter();

	archivesModal = new EventEmitter();
	buyPlan = new EventEmitter<BuyPlan>();

	data = new EventEmitter();

	roleModal = new EventEmitter();

	createTreeGraph = new EventEmitter<CreateTreeGraphData>();
	refactorAppFlowGraphCard = new EventEmitter();

	zeyoIa = new EventEmitter();

	setNameDescriptionModal = new EventEmitter();

	newProcess = new EventEmitter();

	createConnectionTreeGraph = new EventEmitter();

	signOut = new EventEmitter();

	inactivityStartCount = new EventEmitter();
	inactivityRestartCount = new EventEmitter();

	responseChatIaResponse = new EventEmitter();
	notificationIA = new EventEmitter();
}
